"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIREFOX_ZOOM_SENSITIVITY = exports.PINCH_ZOOM_SENSITIVITY = exports.WHEEL_ZOOM_SENSITIVITY = exports.SCALE_STEP = exports.DEFAULT_MIN_SCALE = exports.PREVIEW_CLOSE_GAP_DURATION = exports.PREVIEW_TRANSITION_DURATION = void 0;
exports.PREVIEW_TRANSITION_DURATION = 300;
exports.PREVIEW_CLOSE_GAP_DURATION = 500;
exports.DEFAULT_MIN_SCALE = 0.5;
exports.SCALE_STEP = 0.25;
var pinchWheelRatio = 2.5;
exports.WHEEL_ZOOM_SENSITIVITY = 1.5;
exports.PINCH_ZOOM_SENSITIVITY = exports.WHEEL_ZOOM_SENSITIVITY * pinchWheelRatio;
exports.FIREFOX_ZOOM_SENSITIVITY = 30;
